import React from "react";

function TopWidgets({
  totalEntities = 0,
  newEntitiesThisMonth = 0,
  newEntitiesPercent = "0%",
  marketableEntities = 0,
  marketableEntitiesPercent = "0%",
  onClickTotal,
  onClickNewThisMonth,
  onClickMarketable,
}) {
  const widgets = [
    {
      title: "Total Entities",
      value: totalEntities,
      statClass: "font-bold",
      statContent: <i className="fa fa-building" />,
      onClick: onClickTotal,
      clickable: true,
    },
    {
      title: "New Entities This Month",
      value: newEntitiesThisMonth,
      statClass: "font-bold text-success",
      statContent: (
        <>
          {newEntitiesPercent} <i className="fa fa-level-up" />
        </>
      ),
      onClick: onClickNewThisMonth,
      clickable: true,
    },
    {
      title: "Marketable Entities",
      value: marketableEntities,
      statClass: "font-bold text-info",
      statContent: (
        <>
          {marketableEntitiesPercent} <i className="fa fa-bullhorn" />
        </>
      ),
      onClick: onClickMarketable,
      clickable: true,
    },
  ];

  return (
    <div className="row">
      {widgets.map((widget, index) => (
        <div
          className={
            widgets.length === 3
              ? "col-lg-4 col-md-4"
              : "col-lg-3 col-md-3"
          }
          key={index}
        >
          <div
            className={`card float-e-margins ${
              widget.clickable ? "cursor-pointer" : ""
            }`}
            onClick={widget.onClick || undefined}
            style={widget.clickable ? { cursor: "pointer" } : {}}
          >
            <div className="card-body">
              <h4 className="no-margins">{widget.value}</h4>

              <div className={`stat-percent ${widget.statClass}`}>
                {widget.statContent}
              </div>

              <small>{widget.title}</small>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TopWidgets;